// extracted by mini-css-extract-plugin
module.exports = {"lazy":"_2FC97Nq","show":"_2q4fCfJ"};